let contextmenu = {
  contextmenuDivId: 'workflowDiagram_contextmenu',
  contextmenuDiv: null,
}
// 回调方法
contextmenu.onclickItem_callback = function (event, name) {
  // console.log("onclickItem",event,name);
  alert(event.target.innerText)
}

contextmenu.add = function (menuItems) {
  if (contextmenu.contextmenuDiv) {
    document.body.removeChild(contextmenu.contextmenuDiv)
  }
  // this.contextmenuDiv=`<ul id="contextmenu" style="display:none;">
  //
  // <li><a>逆时针旋转</a></li>
  // <li><a>更改颜色</a></li>
  // <li><a>放大</a></li>
  // <li><a>缩小</a></li>
  // <li><a>撤销上一次操作</a></li>
  // <li><a>删除该节点</a></li>
  // </ul>` ;
  contextmenu.contextmenuDiv = document.createElement('ul') // 在这里创建一个ul标签
  contextmenu.contextmenuDiv.className = 'workflow-contextmenu'
  for (var i = 0; i < menuItems.length; i++) {
    var menuItem = menuItems[i]
    var tempLi = document.createElement('li')
    tempLi['data-menuItem-name'] = menuItem.name
    tempLi.onclick = function (event) {
      contextmenu.onclickItem_callback(event, event.target.innerText)
      contextmenu.hide()
      // contextmenu.onclickItem(event,menuItem);
    }

    tempLi.innerHTML = '<a>' + menuItem.name + '</a>'

    contextmenu.contextmenuDiv.appendChild(tempLi)
  }

  // ul.id=contextmenu.contextmenuDivId;
  // contextmenu.contextmenuDiv.innerHTML =tempLi;
  contextmenu.contextmenuDiv = document.body.appendChild(contextmenu.contextmenuDiv)
}

contextmenu.hide = function () {
  if (contextmenu.contextmenuDiv) {
    document.body.removeChild(contextmenu.contextmenuDiv)
    contextmenu.contextmenuDiv = null
  }
}

contextmenu.addEventListener = function (scene, menuItems, callback) {
  if (callback) {
    contextmenu.onclickItem_callback = callback
  }

  scene.removeEventListener('mouseup')

  scene.addEventListener('mouseup', function (event) {
    // console.log("mouseup",event);
    if (event.button == 2) {
      //  左键
      contextmenu.add(menuItems)
      contextmenu.contextmenuDiv.style.position = 'absolute'
      contextmenu.contextmenuDiv.style.display = ''
      contextmenu.contextmenuDiv.style.top = event.pageY + 'px'
      contextmenu.contextmenuDiv.style.left = event.pageX + 'px'
    } else if (event.button == 0) {
      // 右键
      // 关闭弹出菜单（div）
      contextmenu.hide()
    }
  })
}

export default contextmenu
